import { useCurrency } from "../currency/Currency";
import React from "react";
import ExploreWheel from "../Components/ExploreWheel";
import { Link } from "react-router-dom";
import "../home-store.css";
import PromotedProducts from "../Components/PromotedProducts";
import VideoShowcase from "../Components/VideoShowcase";
import BrandGraphic from "../Components/BrandGraphic";
import ScratcherPartyBanner from "../promotions/ScratcherPartyBanner";

export default function Home() {
  const { money, currency } = useCurrency();
  return (
    <main className="hs-page">
      <section className="hs-hero">
        <div className="hs-wrap hs-hero-grid">
          <div>
            <p className="hs-eyebrow">TECHNOGENIOUS SOLUTIONS · JAMAICA</p>
            <h1>
              The right parts.
              <br />
              <span>The support to match.</span>
            </h1>
            <p className="hs-lead">
              Components, accessories, and technical services for your gaming
              machine. Find what you need, or let our team help you choose.
            </p>
            <div className="hs-actions">
              <Link className="hs-primary" to="/products">
                Shop products →
              </Link>
              <Link className="hs-secondary" to="/contact">
                Talk to our team ↗
              </Link>
            </div>
          </div>
          <div
            className="hs-showcase"
            aria-label="Electronic components illustration"
          >
            <div className="hs-showcase-top">
              <span>ENGINEERED TO CONNECT</span>
              <span className="hs-signal" aria-hidden="true" />
            </div>
            <BrandGraphic />
            <div className="hs-showcase-bottom">
              <span>PARTS / GAMING MACHINES / SUPPORT</span>
              <span>TECHNOGENIOUS ↗</span>
            </div>
          </div>
        </div>
      </section>
      <div className="hs-benefits">
        <div className="hs-wrap">
          <span>Free store pickup</span>
          <span>Local & international delivery</span>
          <span>Product compatibility advice</span>
        </div>
      </div>
      <ScratcherPartyBanner />
      <ExploreWheel />
      <section className="hs-wrap hs-machine-feature" aria-labelledby="home-machines-title">
        <div className="hs-machine-photo"><img src="/installations/installation-updated-03.jpg" alt="Three American Roulette gaming machines installed by Technogenious" loading="lazy"/><span>REAL INSTALLATIONS · JAMAICA</span></div>
        <div><p className="hs-eyebrow">BUILT AROUND YOUR LOCATION</p><h2 id="home-machines-title">Your space. Your gaming setup.</h2><p>Whether you want one machine or a linked setup, explore cabinet styles and choose the components that suit your venue. We’ll confirm compatibility, availability, and installation in your quotation.</p>
        <div className="hs-machine-options"><Link to="/gaming-machines">Buy a machine ↗</Link><Link to="/leasing">Explore leasing ↗</Link><Link to="/build-your-machine">Build your machine ↗</Link></div>
        <a className="hs-primary" href="/gaming-machines#installations">See our installations →</a></div>
      </section>
      <VideoShowcase />
      <PromotedProducts />
      <section className="hs-wrap hs-section">
        <div className="hs-section-heading">
          <div>
            <p className="hs-eyebrow">START WITH WHAT YOU NEED</p>
            <h2>Explore the store</h2>
          </div>
          <Link to="/products">View all products →</Link>
        </div>
        <div className="hs-categories">
          <Link to="/products?q=bill%20acceptor">
            <div className="hs-category-art">
              <BrandGraphic variant="acceptor" />
            </div>
            <span className="hs-category-number">01 / COMPONENTS</span>
            <h3>Bill acceptors</h3>
            <p>
              Find a replacement, or ask us what fits your existing setup.
            </p>
            <span className="hs-card-action">Browse bill acceptors ↗</span>
          </Link>
          <Link to="/products?q=power">
            <div className="hs-category-art">
              <BrandGraphic variant="power" />
            </div>
            <span className="hs-category-number">02 / CONNECTIONS</span>
            <h3>Power & cables</h3>
            <p>
              Explore power supplies, cables, and connections for your gaming
              machine.
            </p>
            <span className="hs-card-action">Browse power products ↗</span>
          </Link>
          <Link to="/products">
            <div className="hs-category-art">
              <BrandGraphic />
            </div>
            <span className="hs-category-number">03 / THE COLLECTION</span>
            <h3>Parts & accessories</h3>
            <p>
              Browse the full collection for your next repair, replacement, or
              upgrade.
            </p>
            <span className="hs-card-action">Explore all products ↗</span>
          </Link>
        </div>
      </section>
      <section className="hs-support">
        <div className="hs-wrap hs-support-grid">
          <div>
            <p className="hs-eyebrow">MORE THAN A PRODUCT LIST</p>
            <h2>
              Not sure which part fits?
              <br />
              Start with a conversation.
            </h2>
            <p>
              Tell us your machine’s model and what you need help with. We can advise on compatibility, repairs, installation, and maintenance.
            </p>
            <Link className="hs-primary" to="/contact">
              Get product advice ↗
            </Link>
          </div>
          <div className="hs-service-list">
            <div>
              <span>01</span>
              <h3>Repairs & maintenance</h3>
              <p>Get a fault looked at, or ask about ongoing maintenance.</p>
            </div>
            <div>
              <span>02</span>
              <h3>Installation & setup</h3>
              <p>Ask us about installing and configuring your machine.</p>
            </div>
            <Link to="/services">Explore our services →</Link>
          </div>
        </div>
      </section>
      <section className="hs-wrap hs-section">
        <p className="hs-eyebrow">PLAN YOUR ORDER</p>
        <h2>Pickup or delivery. Your choice.</h2>
        <div className="hs-delivery">
          <div>
            <h3>Collect in store</h3>
            <p>Select free store pickup at checkout.</p>
            <strong>Free</strong>
          </div>
          <div>
            <h3>Deliver locally</h3>
            <p>
              Bearer delivery to nearby addresses is {money(50)} {currency}. Knutsford Delivery and Door Way Express are also available; each courier sets and collects its own delivery charge.
            </p>
            <Link to="/contact">Confirm your delivery area ↗</Link>
          </div>
          <div>
            <h3>Deliver internationally</h3>
            <p>
              International delivery is estimated at {money(150)} {currency} and may change. Confirm the arrangements with our team.
            </p>
            <Link to="/contact">Ask about international delivery ↗</Link>
          </div>
        </div>
        <p className="hs-currency">
          Prices are shown in {currency}. Card payments are charged in USD; bank transfers are available in USD or JMD. Check your delivery choice and final total before you pay.
        </p>
      </section>
      <section className="hs-wrap hs-final">
        <div>
          <h2>Ready to find your next part?</h2>
          <p>Browse the collection and add what you need.</p>
        </div>
        <Link className="hs-primary" to="/products">
          Start shopping →
        </Link>
      </section>
    </main>
  );
}
